import React, { useState } from "react"
import Card from "@material-ui/core/Card";
import moment from 'moment'
import { formatAsMoneyFromBilling } from '../../utils/utils'
import * as S from './styles.js'
import { CircularProgress } from '@material-ui/core';
import axios from "axios";

function ChargeCard(props) {

    const { charge } = props
    const [invoiceLoading, setInvoiceLoading] = useState(false)
    const [invoiceError, setInvoiceError] = useState(null)
    const getInvoicePDF = async (invoice_key) => {
        setInvoiceLoading(true)
        try {
            const response = await axios.get(`/dash/companies/invoice/${invoice_key}`, {
                responseType: 'blob'
            });

            const blobUrl = URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `Fatura_${charge.charge_key}_${moment(charge.created_at).format('YYYY_MM')}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl)

        } catch (error) {
            setInvoiceError('Erro ao baixar a fatura')
            console.error('Erro ao tentar baixar a fatura', error)
        } finally {
            setInvoiceLoading(false)
        }
    }

    const handleInvoiceBadge = (invoice) => {
        if (invoice?.invoice_status === 'available') {
            return <S.GreenBadge>
                {
                    invoiceLoading ?
                        <CircularProgress />
                        :
                        <div style={{cursor: 'pointer'}} onClick={() => getInvoicePDF(invoice.invoice_key)}>
                            Disponível
                        </div>
                }
            </S.GreenBadge>
        } else {
            return <S.RedBadge>
                Indisponível
            </S.RedBadge>
        }
    }

    return (
        <Card className={["listCard", "collapse"].join(" ")}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div class="listCardItem normalText subtitleSize"
                        style={{ flex: "1 1 220px", textAlign: "center" }}
                    >
                        {charge.charge_key}
                    </div>
                    <div
                        className={["listCardItem", "normalText", "subtitleSize"].join(" ")}
                        style={{ flex: "1 1 130px", textAlign: "center" }}
                    >
                        {formatAsMoneyFromBilling(charge.amount, "-")}
                    </div>
                    <div
                        className={["listCardItem", "normalText", "subtitleSize", "noWrap"].join(" ")}
                        style={{ flex: "1 1 110px", textAlign: "center" }}
                    >
                        {moment(charge.created_at).format("DD/MM/YYYY HH:mm:ss")}
                    </div>
                    <div
                        className={["listCardItem", "normalText", "subtitleSize", "noWrap"].join(" ")}
                        style={{ flex: "1 1 110px", textAlign: "center" }}
                    >
                        { invoiceError 
                            ? 
                                <S.RedBadge>
                                    Erro
                                </S.RedBadge> 
                            : handleInvoiceBadge(charge.invoice)
                        }
                    </div>
                </div>
            </Card>

    )
}

export default ChargeCard